<template><div><h2>Actionsheet</h2>
<ul>
<li>[feature] 支持数组定义菜单 #950 @wuchuguang</li>
</ul>
<h2>Datetime</h2>
<ul>
<li>[fix] 修复<code>label</code>宽度没有受限于<code>group</code>设置</li>
</ul>
<h2>Icon</h2>
<ul>
<li>[feature] 更新<code>WeUI</code>样式到最新版本</li>
<li>[change] <code>type</code>参数由下划线变为中划线，组件内部做了兼容保证升级时无影响</li>
</ul>
<h2>Marquee</h2>
<ul>
<li>[feature] 新组件</li>
</ul>
<h2>Msg</h2>
<ul>
<li>[feature] 新组件</li>
</ul>
<h2>Search</h2>
<ul>
<li>[feature] 更新到<code>WeUI</code>最新代码</li>
<li>[enhance] 当<code>value</code>为空时，不显示清除按钮</li>
</ul>
<h2>ViewBox</h2>
<ul>
<li>[feature] 增加<code>body-padding-top</code>及<code>body-padding-bottom</code>方便设定上下<code>padding</code>值</li>
</ul>
<h2>XButton</h2>
<ul>
<li>[feature] 更新到 <code>WeUI</code> 最新版本</li>
<li>[feature] 支持 <code>prop:isLoading</code></li>
</ul>
<h2>XDialog</h2>
<ul>
<li>[fix] 修复<code>transition</code>绑定</li>
</ul>
<h2>XNumber</h2>
<ul>
<li>[feature] 升级<code>WeUI</code>样式</li>
<li>[fix] 修复<code>label</code>样式不受控于<code>group</code>设置</li>
<li>[feature] 支持<code>align</code>属性</li>
</ul>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0_zh-CN-291.vue?6dc0b0f0